interface SanitizeDownloadFileNameOptions {
  /** Drop a trailing UI category chip like `(HTTP)` from the filename base. */
  stripCategoryChip?: boolean
}

/** Normalize user-visible document labels into filesystem-safe filename bases. */
export function sanitizeDownloadFileName(
  input: string,
  { stripCategoryChip = true }: SanitizeDownloadFileNameOptions = {}
): string {
  const baseInput = stripCategoryChip ? input.replace(/\s*\([^)]*\)\s*$/u, '') : input
  const normalized = baseInput
    .replace(/[^\p{L}\p{N}._-]+/gu, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')

  return normalized || 'document'
}
